import React, { ReactElement, useCallback, useContext, useState } from 'react'
import { campaignContactData, createCampaignCampaignVariable, createWhatsappTemplatePayload, flowVariables, getTemplateDetails, updateCampaignPayload, whatsappTemplateButton, whatsappTemplateHeaderVariable } from '../../../models/axiosModel';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { getAllowedFileTye, getVisitWebsiteUrl, isCarouselTemplate } from './campaignConstant';
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import accordionStyles from "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import globalStyles from "../../../assets/styles/global.module.scss";
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import Required from '../../utility/required';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { debounce, DebouncedFunc } from 'lodash';
import FileUpload from '../../utility/fileUpload/fileUpload';
import { checkIfBtnDynamicVarExist, flagShowBodyVariableForCarouselTemplate, flagShowButtonVariableForCarouselTemplate, flagShowCarouselGlobalHeaderVariable, getFileTypeImgIcon, getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from '../../../utils/constants';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import TemplateVariableTable from './templateVariableTable';
import axios from 'axios';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import validator from 'validator';
import { getVendorField } from '../../../utils/whiteLabelling';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { getLocationCoordinateWarning, isValidLatitudeValue, isValidLongitudeValue } from '../templatelibrary/constant';

interface CampaignVariableMapping {
    campaignPayload: updateCampaignPayload,
    setCampaignPayload: React.Dispatch<React.SetStateAction<updateCampaignPayload>>,
    setCarouselTemplatePayload: React.Dispatch<React.SetStateAction<getTemplateDetails | null>>,
    checkDisableAllFields: () => boolean,
    inValidId: number[],
    getAllButtonVariableData: (button: whatsappTemplateButton[]) => whatsappTemplateHeaderVariable[], 
    getValueFromContactData: (contact_field_id: number) => string | null | undefined,
    buttonVariableData: whatsappTemplateHeaderVariable[] | null, 
    getContactFieldIdFromValue: (value: string) => number,
    setCreateTemplatePayload: React.Dispatch<React.SetStateAction<createWhatsappTemplatePayload>>,
    setInvalidId: React.Dispatch<React.SetStateAction<number[]>>,
    inValidIdRef: React.MutableRefObject<number[]>,
    isFlowTemplate: (messageTemplateDetail: any) => boolean, 
    getFlowInputVariablesFromTemplate: (messageTemplateDetail: any) => flowVariables[],
} 

const CampaignVariableMapping: React.FC<CampaignVariableMapping> = (props) => {

    const {campaignPayload, setCampaignPayload, setCarouselTemplatePayload, checkDisableAllFields, inValidId, setInvalidId, inValidIdRef, getAllButtonVariableData, getValueFromContactData, buttonVariableData, getContactFieldIdFromValue, setCreateTemplatePayload, isFlowTemplate, getFlowInputVariablesFromTemplate} = props;
    const { messageTemplateDetail } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { campaignContactData } = useContext(ContactContext) as ContactContextPayload;
    const { flagLoading, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))
    
    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState({ filename: "", percent: 0 });
    const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);

    const uploadFileHandler = async (e: any, flagCarousel: boolean, whatsapp_template_carousel_variation_id?: number, whatsapp_template_dynamic_variable_id?: number) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setFiles([file]);

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }
            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData, config).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                // rr.page_field_id = id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })
                    if(flagCarousel){
                        onChangeOfCardVariablesFallbackValue(whatsapp_template_carousel_variation_id || 0, whatsapp_template_dynamic_variable_id || 0, res.data.data.file_path, "header");
                    } else {
                        setCampaignPayload((prev) => ({
                            ...prev,
                            campaign_variable: prev.campaign_variable.map((variable, ind) => {
                                if (ind === 0) {
                                    return {
                                        ...variable, 
                                        campaign_variable_fallback_value: res.data.data.file_path,
                                    }
                                }
                                return variable;
                            })
                        }))
                    }
                    setHeaderDataValue(res.data.data.file_path);
                    setIsFileUploaded(false);
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                console.error(err)
            });
            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }
    
    const removeFileHandler = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        await agent.removeUploadedFile.delete(files[0].file_data.google_storage_id).then(async (res) => {
            if (res.data.status) {
                setFiles([]);
                showSuccess("File Deleted Successfully")
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        setFiles([]);
    } 

    const handleValidWebsite = (website_value: string, index: number) => {
        if (website_value.trim().length > 0) {
            let temp = validator.isURL(website_value)
            if (temp) {
                if (inValidIdRef.current.includes(index)) {
                    setInvalidId(inValidIdRef.current.filter((ele: number) => ele != index))
                    inValidIdRef.current = inValidIdRef.current.filter((ele: number) => ele != index);
                } else {
                }
            } else {
                if (inValidIdRef.current.includes(index)) {
                } else {
                    setInvalidId([...inValidId, index])
                    inValidIdRef.current = [...inValidIdRef.current, index];
                }
            }
        } else if (website_value.trim().length == 0) {
            if (inValidIdRef.current.includes(index)) {
                setInvalidId(inValidIdRef.current.filter((ele: number) => ele != index))
                inValidIdRef.current = inValidIdRef.current.filter((ele: number) => ele != index);
            } else {
            }
        }
    }

    const onBlurOfFallBackOfBtnVar = useCallback(
        debounce((value: string, index: number) => {
            handleValidWebsite(value, index);
        }, 1200), []
    );

    const onChangeOfCardVariablesFallbackValue = (whatsapp_template_carousel_variation_id: number, whatsapp_template_dynamic_variable_id: number, value: string, type: string) => {
        setCampaignPayload((prev) => ({
            ...prev, 
            campaign_carousel_card: prev.campaign_carousel_card ? prev.campaign_carousel_card.map((cCard) => {
                if(cCard.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id){
                    return {
                        ...cCard, 
                        campaign_variable: cCard.campaign_variable.map((vari) => {
                            if(vari.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                                return {
                                    ...vari, 
                                    campaign_variable_fallback_value: value,
                                }
                            }
                            return vari;
                        })
                    }
                }
                return cCard;
            }) : [],
        })); 

        switch(type.toLowerCase()){
            case "header": 
                onBlurOfFallBackOfBtnVar(value, whatsapp_template_dynamic_variable_id);
                setCarouselTemplatePayload((prev) => {
                    if(!prev) return prev;
                    return {
                        ...prev,
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) => { 
                            if(template.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id){
                                return {
                                    ...template, 
                                    whatsapp_template_header: {
                                        ...template.whatsapp_template_header, 
                                        whatsapp_template_header_data: template.whatsapp_template_header?.whatsapp_template_header_data?.map((variable) => { 
                                            return {
                                                ...variable, 
                                                whatsapp_template_header_data_value: value,
                                            }
                                        })
                                    }
                                }
                            }
                            return template;
                        })
                    }
                });
                break;
            case "body": 
                setCarouselTemplatePayload((prev) => {
                    if(!prev) return prev; 
                    return {
                        ...prev, 
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) => { 
                            if(template.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id){
                                return {
                                    ...template, 
                                    whatsapp_template_body: {
                                        ...template.whatsapp_template_body, 
                                        whatsapp_template_body_variable_data: template.whatsapp_template_body?.whatsapp_template_body_variable_data?.map((bVariable) => { 
                                            if(bVariable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                                                return {
                                                    ...bVariable, 
                                                    whatsapp_template_dynamic_variable_sample_value: value,
                                                }
                                            }
                                            return bVariable;
                                        })
                                    }
                                }
                            } 
                            return template;
                        })
                    }
                }); 
                break;
            case "button": 
                onBlurOfFallBackOfBtnVar(value, whatsapp_template_dynamic_variable_id);
                setCarouselTemplatePayload((prev) => {
                    if(!prev) return prev; 
                    return {
                        ...prev, 
                        whatsapp_template_data: prev?.whatsapp_template_data?.map((template) => { 
                            if(template.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id){
                                return {
                                    ...template, 
                                    whatsapp_template_button: template.whatsapp_template_button?.map((button) => {
                                        return {
                                            ...button, 
                                            whatsapp_template_button_data: button.whatsapp_template_button_data?.map((btnData) => {
                                                return {
                                                    ...btnData, 
                                                    whatsapp_template_button_sub_type_field_data: btnData.whatsapp_template_button_sub_type_field_data?.map((subTypeFieldData) => {
                                                        return {
                                                            ...subTypeFieldData, 
                                                            whatsapp_template_button_field_data_variable: subTypeFieldData.whatsapp_template_button_field_data_variable?.map((btnFieldVariable) => {
                                                                if(btnFieldVariable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                                                                    return {
                                                                        ...btnFieldVariable, 
                                                                        whatsapp_template_dynamic_variable_sample_value: value,
                                                                    }
                                                                } 
                                                                return btnFieldVariable;
                                                            }) 
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            } 
                            return template;
                        })
                    }
                })
                break;
        }
    }

    const onChangeOfFallbackValueGlobalCarouselTemplateBody = (whatsapp_template_dynamic_variable_id: number, value: string) => {
        setCampaignPayload((prev) => ({
            ...prev, 
            campaign_variable: prev.campaign_variable.map((vari) => {
                if(vari.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                    return {
                        ...vari, 
                        campaign_variable_fallback_value: value,
                    }
                }
                return vari;
            })
        }));  
        const val = getValueFromContactData(Number(campaignPayload.campaign_variable?.find((vari) => vari?.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id)?.contact_field_id)) as string;
        if(val?.length == 0){
            setCarouselTemplatePayload((prev) => {
                if(!prev) return prev; 
                return {
                    ...prev, 
                    whtatsapp_carousel_header_variable_data: prev.whtatsapp_carousel_header_variable_data?.map((hVariable) => { 
                        if(hVariable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                            return {
                                ...hVariable, 
                                whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value : hVariable.whatsapp_template_dynamic_variable_key,
                            }
                        } 
                        return hVariable;
                    })
                }
            });
        }
    } 

    const onChangeOfValueOfGlobalCarouselTemplateBody = (value: string | null, whatsapp_template_dynamic_variable_id: number) => {
        setCampaignPayload((prev) => ({
            ...prev, 
            campaign_variable: prev?.campaign_variable?.map((vari) => {
                if(vari?.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                    return {
                        ...vari, 
                        contact_field_id: value ? getContactFieldIdFromValue(value) : "",
                        campaign_variable_name: value ? value : "",
                    }
                }
                return vari;
            })
        })); 
        setCarouselTemplatePayload((prev) => {
            if(!prev) return prev;
            return {
                ...prev, 
                whtatsapp_carousel_header_variable_data: prev?.whtatsapp_carousel_header_variable_data?.map((hVariable) => {
                    if(hVariable?.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                        return {
                            ...hVariable, 
                            whatsapp_template_dynamic_variable_sample_value: value ? value : campaignPayload?.campaign_variable?.find((vari) => vari?.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || hVariable?.whatsapp_template_dynamic_variable_key,
                        }
                    }
                    return hVariable;
                })
            }
        })
    }

    const flagShowHeaderVariables = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data.length > 0 &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length > 0)
    } 

    const flagShowBodyVariable = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length > 0);
    }

    const flagShowButtonVariable = () => {
        return (messageTemplateDetail && messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button &&
            messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button.length > 0 && checkIfBtnDynamicVarExist(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button)
        )
    } 

    const handleValidLocationCoordinate = (value: string, variableKey: string, variableId: number) => {
        const normalizedKey = variableKey?.toLowerCase() ?? "";
        const isValid = normalizedKey === "{{latitude}}"
            ? isValidLatitudeValue(value)
            : normalizedKey === "{{longitude}}"
                ? isValidLongitudeValue(value)
                : true;

        setInvalidId((prev) => {
            if (isValid) {
                return prev.filter((id) => id !== variableId);
            }
            return prev.includes(variableId) ? prev : [...prev, variableId];
        });
    }

    const renderHeaderVariableValue = (ind: number, whatsapp_template_dynamic_variable_id: number, variableKey: string) => {
        if (messageTemplateDetail) {
            const headerType = messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_type_name.toLowerCase();
            let fileTypeAllowed = '';

            const isLocationCoordinateField = headerType === "location"
                && ["{{latitude}}", "{{longitude}}"].includes(variableKey.toLowerCase());
            const isInvalidLocationCoordinate = isLocationCoordinateField
                && inValidId.includes(whatsapp_template_dynamic_variable_id);
            const locationCoordinateWarning = isInvalidLocationCoordinate
                ? getLocationCoordinateWarning(variableKey)
                : "";

            switch (headerType) {
                case "text":
                case "location":
                    return <>
                    <Box className={`${globalStyles.fullwidth} ${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                        <TextField
                            // value={campaignPayload.campaign_variable[ind].campaign_variable_fallback_value ? campaignPayload.campaign_variable[ind].campaign_variable_fallback_value : ""} 
                            value={campaignPayload.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                            placeholder='Enter Value'
                            onChange={(e) => {
                                if (isLocationCoordinateField) {
                                    handleValidLocationCoordinate(
                                        e.target.value,
                                        variableKey,
                                        whatsapp_template_dynamic_variable_id
                                    );
                                } 
                                handleChangeFallbackValue(e.target.value, ind, "header", whatsapp_template_dynamic_variable_id);
                            }}
                            className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                            disabled={checkDisableAllFields()}
                            style={{
                                border: isInvalidLocationCoordinate ? "1px solid red" : undefined,
                                height: "fit-content",
                            }}
                        />

                        {locationCoordinateWarning && (
                            <span className={style.invalidUrlSpan}>
                                {locationCoordinateWarning}
                            </span>
                        )}

                    </Box>
                    </>;
                case "image":
                    fileTypeAllowed = '.jpg, .jpeg';
                    break;
                case "video":
                    fileTypeAllowed = '.mp4';
                    break;
                case "document":
                    fileTypeAllowed = '.pdf';
                    break;
                default:
                    return <></>;
            }

            if (headerType === "image" || headerType === "video" || headerType === "document") {
                return (
                    <>
                        <Grid container gap={"12px"} flexWrap={"nowrap"}>
                            <Grid item xs={10.5}>
                                <Grid container direction={"column"}>
                                    <TextField
                                        // value={campaignPayload.campaign_variable?.[ind]?.campaign_variable_fallback_value ? campaignPayload.campaign_variable[ind].campaign_variable_fallback_value : ""}
                                        value={campaignPayload.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                        placeholder='Enter media URL or Upload'
                                        onChange={(e) => { handleChangeFallbackValue(e.target.value, ind, "header", whatsapp_template_dynamic_variable_id, headerType); }}
                                        // onBlur={(e) => { setHeaderDataValue(e.target.value) }}
                                        className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                        sx={{ border: inValidId.includes(ind + ind) ? "1px solid red" : "" }}
                                        disabled={checkDisableAllFields()}
                                    />
                                    {inValidId.includes(whatsapp_template_dynamic_variable_id) && <span className={style.invalidUrlSpan}>Please Enter Valid URL</span>}
                                </Grid>
                            </Grid>
                            <Grid item>
                                <FileUpload
                                    uploadedFileDetails={files}
                                    multipleFileAllow={true}
                                    fileSizeAllowed={getWhatsappMediaSizeLimit(headerType)}
                                    fileTypeAllowed={getWhatsappMediaAllowedFileTypes(headerType)?.allowedType}
                                    fileNumberAllowed={2}
                                    uploadFileHandler={(e) => uploadFileHandler(e, false)}
                                    removeFileHandler={removeFileHandler}
                                    isDeleteFileIconVisible={isFileUploaded}
                                    flagShowJustIcon={true}
                                    isDisabled={checkDisableAllFields()} 
                                    flagWhatsapp={true}
                                />
                            </Grid>
                        </Grid>
                    </>
                );
            }
        }
    } 

    const updatedIndexForBodyVariables = (ind: number) => {
        if (messageTemplateDetail) {
            return (messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data.length > 0 &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length > 0)
                ?
                ind + messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length
                : ind;
        }
        return ind;
    } 

    const updatedIndexForBtnVariable = (ind: number) => {
        if (messageTemplateDetail) {
            const headerFlag: boolean = (messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data.length > 0 &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length > 0);

            const bodyFlag: boolean = (messageTemplateDetail.whatsapp_template_data && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data &&
                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length > 0);

            let updatedInd = ind;
            if (headerFlag) {
                updatedInd += messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length;
            }
            if (bodyFlag) {
                updatedInd += messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length;
            }
            return updatedInd;
        }
        return ind;
    } 

    const setHeaderDataValue = (value: string) => {
        setCreateTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_data: {
                ...prev.whatsapp_template_data,
                whatsapp_template_header: {
                    ...prev.whatsapp_template_data?.whatsapp_template_header,
                    whatsapp_template_header_data: prev.whatsapp_template_data?.whatsapp_template_header.whatsapp_template_header_data.map(headerData => {
                        return {
                            ...headerData,
                            whatsapp_template_header_data_value: value.trim().length > 0 ? value : headerData.whatsapp_template_header_data_value,
                        }
                    })
                }
            }
        }))
    }

    const setHeaderVariableSampleValue = (value: string, whatsapp_template_dynamic_variable_id: number) => {
        setCreateTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_data: {
                ...prev.whatsapp_template_data,
                whatsapp_template_header: {
                    ...prev.whatsapp_template_data?.whatsapp_template_header,
                    whatsapp_template_header_data: prev.whatsapp_template_data?.whatsapp_template_header.whatsapp_template_header_data.map(headerData => {
                        return {
                            ...headerData,
                            whatsapp_template_header_variable_data: headerData?.whatsapp_template_header_variable_data?.map((variable) => {
                                if(variable?.whatsapp_template_dynamic_variable_id === whatsapp_template_dynamic_variable_id){
                                    return {
                                        ...variable,
                                        whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value : variable.whatsapp_template_dynamic_variable_key,
                                    }
                                }
                                return variable;
                            })
                        }
                    })
                }
            }
        }))
    }

    const handleChangeField = (value: string | null, ind: number, variable: string, whatsapp_template_dynamic_variable_id: number) => {
        const updatedMappingValues: createCampaignCampaignVariable[] = campaignPayload.campaign_variable.map((variable) => {
            if(variable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                return {
                    ...variable, 
                    contact_field_id: value ? getContactFieldIdFromValue(value) : "",
                    campaign_variable_name: value ? value : "",
                }
            }
            return variable;
        })
        setCampaignPayload((prev) => ({
            ...prev,
            campaign_variable: updatedMappingValues,
        }));

        // setDropdownOptionFunction(updatedMappingValues);

        switch (variable) {
            case "header":
                setHeaderVariableSampleValue(value ? value : campaignPayload.campaign_variable[ind].campaign_variable_fallback_value ? campaignPayload.campaign_variable[ind].campaign_variable_fallback_value : "", whatsapp_template_dynamic_variable_id);
                break;
            case "body":
                setCreateTemplatePayload((prev) => ({
                    ...prev,
                    whatsapp_template_data: {
                        ...prev.whatsapp_template_data,
                        whatsapp_template_body: {
                            ...prev.whatsapp_template_data.whatsapp_template_body,
                            whatsapp_template_body_variable_data: prev.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_variable_data.map(
                                (variable) => {
                                    if(variable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                                        return {
                                            ...variable,
                                            whatsapp_template_dynamic_variable_sample_value: value ? value : (campaignPayload.campaign_variable[ind].campaign_variable_fallback_value && campaignPayload.campaign_variable[ind].campaign_variable_fallback_value.length > 0) ? campaignPayload.campaign_variable[ind].campaign_variable_fallback_value : variable.whatsapp_template_dynamic_variable_key,
                                        };
                                    }
                                    return variable;
                                }
                            ),
                        },
                    },
                }));
                break;
            case "button":
                break;
        }

    } 

    const handleChangeFallbackValue = (value: string, ind: number, variableType: string, whatsapp_template_dynamic_variable_id: number, type?: String) => {
        setCampaignPayload((prev) => ({
            ...prev,
            campaign_variable: prev.campaign_variable.map((variable) => {
                if(variable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                    if (variableType == "header" && files.length > 0) {
                        removeFileHandler();
                    } 
                    return {
                        ...variable, 
                        campaign_variable_fallback_value: value,
                    }
                }
                return variable;
            })
        }))
        const val = getValueFromContactData(Number(campaignPayload.campaign_variable[ind]?.contact_field_id)) as string;

        switch (variableType) {
            case "header":
                if(val?.length === 0){
                    setHeaderVariableSampleValue(value, whatsapp_template_dynamic_variable_id);
                }
                if (type) {
                    onBlurOfFallBackOfBtnVar(value, whatsapp_template_dynamic_variable_id);
                }
                break;
            case "body":
                if (val?.length == 0) {
                    setCreateTemplatePayload((prev) => ({
                        ...prev,
                        whatsapp_template_data: {
                            ...prev.whatsapp_template_data,
                            whatsapp_template_body: {
                                ...prev.whatsapp_template_data.whatsapp_template_body,
                                whatsapp_template_body_variable_data: prev.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_variable_data.map(
                                    (variable) => {
                                        if(variable.whatsapp_template_dynamic_variable_id == whatsapp_template_dynamic_variable_id){
                                            return {
                                                ...variable,
                                                whatsapp_template_dynamic_variable_sample_value: value.trim().length > 0 ? value : variable.whatsapp_template_dynamic_variable_key,
                                            };
                                        }
                                        return variable;
                                    }
                                ),
                            },
                        },
                    }));
                }
                break;
            case "button":
                onBlurOfFallBackOfBtnVar(value, whatsapp_template_dynamic_variable_id);
                break;
        }
    }

    const flagShowFlowVariables = () => {
        return (messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button?.find((btn: any) => btn?.whatsapp_template_button_type_name?.toLowerCase() == "flow")?.whatsapp_template_button_data?.[0]?.whatsapp_flow_data
            ?.whatsapp_flow_version_data?.find((version: any) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published")
            ?.whatsapp_flow_variables?.filter((flowVar: any) => flowVar?.input_variable_flag)?.length > 0
        )
    }

    return (
        <> 
            { campaignPayload.meta_integration_whatsapp_phone_number_id != 0 && (messageTemplateDetail) && ((flagShowHeaderVariables() || flagShowBodyVariable() || flagShowButtonVariable()) || isCarouselTemplate(messageTemplateDetail) || isFlowTemplate(messageTemplateDetail)) ?
                <Grid item xs={12} className={ `${isCarouselTemplate(messageTemplateDetail) ? style.carouselTemplateCampaignMessageTypeBox : style.campaignMessageTypeBox} ${globalStyles.fullwidth}`}>
                    <Grid container direction={"column"} gap={"10px"}> 
                        {isCarouselTemplate(messageTemplateDetail) ? 
                            <>
                                {flagShowCarouselGlobalHeaderVariable(messageTemplateDetail) && 
                                    <>
                                        <Grid item>
                                            <Typography className={style.assignValuesTitle}>Template Body <Required /></Typography>
                                        </Grid>
                                        <Grid item className={globalStyles.fullwidth}> 
                                            <TemplateVariableTable
                                                templateType='carousel' 
                                                variableType='globalHeader'
                                                tableBodyContent={
                                                    <TableBody>
                                                        {messageTemplateDetail?.whtatsapp_carousel_header_variable_data.map((variable, ind) => {
                                                            return (
                                                                <TableRow key={ind} className={style.tableRow}>
                                                                    <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                    <TableCell className={style.tableSubHeadingFontStyle}>
                                                                        <Autocomplete
                                                                            className={`${style.whatsappCampaignDropDowns} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                            options={(campaignContactData && campaignContactData[0].contact && campaignContactData[0].contact.length > 0 && campaignContactData[0].contact[0].contact_data.length > 0) ? campaignContactData[0].contact[0].contact_data.map((contact: campaignContactData) => contact.contact_field_name) : []}
                                                                            value={getValueFromContactData(Number(campaignPayload?.campaign_variable?.find((vari) => vari?.whatsapp_template_dynamic_variable_id == variable?.whatsapp_template_dynamic_variable_id)?.contact_field_id))}
                                                                            getOptionLabel={(option) => option}
                                                                            onChange={(e, value) => onChangeOfValueOfGlobalCarouselTemplateBody(value, variable?.whatsapp_template_dynamic_variable_id)}
                                                                            renderInput={(params) => <TextField {...params} placeholder="Eg. PhoneNumber, firstName" />}
                                                                            disabled={checkDisableAllFields()}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell className={style.tableSubHeadingFontStyle}>
                                                                        <TextField
                                                                            value={campaignPayload?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                            placeholder='Enter Fallback Value'
                                                                            onChange={(e) => onChangeOfFallbackValueGlobalCarouselTemplateBody(variable.whatsapp_template_dynamic_variable_id, e.target.value)}
                                                                            className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                            disabled={checkDisableAllFields()}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                }
                                            />
                                        </Grid>
                                    </>
                                } 

                                <Grid container direction={"column"} gap={2}>
                                    {messageTemplateDetail?.whatsapp_template_data?.sort((cardA, cardB) => cardA.whatsapp_template_carousel_variation_id - cardB.whatsapp_template_carousel_variation_id)?.map((card, cardIndex) => {
                                        return (
                                            <Grid item>
                                                <Accordion key={cardIndex} className={`${accordionStyles.agentAccordion} ${accordionStyles.transitionAccordion} ${accordionStyles.accordionDesignStyle}`}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1-content"
                                                        id="panel1-header" 
                                                        className={globalStyles.carouselCardAccordion}
                                                    >
                                                        <Grid container gap={"6px"} justifyContent={"space-between"}>
                                                            <Grid item className={accordionStyles.stepTextStyle}>
                                                                {`Card: ${cardIndex + 1}`}
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionSummary> 
                                                    <AccordionDetails className={accordionStyles.accordionDetailsStyle}>
                                                        <Grid item xs={12}>
                                                            <Grid container gap={2}>
                                                                {/* Card Header Variable */}
                                                                <Grid item xs={12}>
                                                                    <Grid container gap={1}>
                                                                        <Grid item xs={12}>
                                                                            <Typography className={style.assignValuesTitle}>Header for Card {cardIndex+ 1} <Required /></Typography>
                                                                        </Grid>
                                                                        <Grid item className={globalStyles.fullwidth}> 
                                                                            <TemplateVariableTable 
                                                                                templateType='carousel'
                                                                                tableBodyContent={
                                                                                    <TableBody>
                                                                                        {card.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.map((variable, ind) => {
                                                                                            return (
                                                                                                <TableRow key={ind} className={style.tableRow}>
                                                                                                    <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                    <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                                        <Grid item xs={12} className={globalStyles.fullwidth}>
                                                                                                            <Grid container flexWrap={"nowrap"} gap={"12px"}>
                                                                                                                <Grid item xs={10.5}>
                                                                                                                    <Grid container direction={"column"}>
                                                                                                                        <TextField
                                                                                                                            value={campaignPayload.campaign_carousel_card?.find((cCard) => cCard.whatsapp_template_carousel_variation_id == card.whatsapp_template_carousel_variation_id)?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                                                                            placeholder='Enter media URL or Upload'
                                                                                                                            onChange={(e) => onChangeOfCardVariablesFallbackValue(card.whatsapp_template_carousel_variation_id, variable.whatsapp_template_dynamic_variable_id, e.target.value, "header") }
                                                                                                                            // onBlur={(e) => { setHeaderDataValue(e.target.value) }}
                                                                                                                            className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                                                            sx={{ border: inValidId.includes(variable.whatsapp_template_dynamic_variable_id) ? "1px solid red" : "" }}
                                                                                                                            disabled={checkDisableAllFields()}
                                                                                                                        />
                                                                                                                        {inValidId.includes(variable.whatsapp_template_dynamic_variable_id) && <span className={style.invalidUrlSpan}>Please Enter Valid URL</span>}
                                                                                                                    </Grid>
                                                                                                                </Grid>
                                                                                                                <Grid item xs={1}>
                                                                                                                    <FileUpload
                                                                                                                        uploadedFileDetails={files}
                                                                                                                        multipleFileAllow={true}
                                                                                                                        fileSizeAllowed={getWhatsappMediaSizeLimit(card.whatsapp_template_header?.whatsapp_template_header_type_name)}
                                                                                                                        fileTypeAllowed={getWhatsappMediaAllowedFileTypes(card.whatsapp_template_header?.whatsapp_template_header_type_name)?.allowedType}
                                                                                                                        fileNumberAllowed={2}
                                                                                                                        uploadFileHandler={(e) => uploadFileHandler(e, true, card.whatsapp_template_carousel_variation_id, variable.whatsapp_template_dynamic_variable_id)}
                                                                                                                        removeFileHandler={removeFileHandler}
                                                                                                                        isDeleteFileIconVisible={isFileUploaded}
                                                                                                                        flagShowJustIcon={true}
                                                                                                                        isDisabled={checkDisableAllFields()}
                                                                                                                        flagWhatsapp={true}
                                                                                                                    />
                                                                                                                </Grid>
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                        })}
                                                                                    </TableBody>
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                
                                                                {/* Card Body Variables */}
                                                                {flagShowBodyVariableForCarouselTemplate(card.whatsapp_template_carousel_variation_id, messageTemplateDetail) && 
                                                                    <Grid item xs={12}>
                                                                        <Grid container gap={1}>
                                                                            <Grid item xs={12}>
                                                                                <Typography className={style.assignValuesTitle}>Body for Card {cardIndex+ 1} <Required /></Typography>
                                                                            </Grid>
                                                                            <Grid item className={globalStyles.fullwidth}> 
                                                                                <TemplateVariableTable 
                                                                                    templateType='carousel'
                                                                                    tableBodyContent={
                                                                                        <TableBody>
                                                                                            {card.whatsapp_template_body?.whatsapp_template_body_variable_data?.map((variable, ind) => {
                                                                                                return (
                                                                                                    <TableRow key={ind} className={style.tableRow}>
                                                                                                        <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                        <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                                            <TextField
                                                                                                                value={campaignPayload?.campaign_carousel_card?.find((cCard) => cCard.whatsapp_template_carousel_variation_id == card.whatsapp_template_carousel_variation_id)?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                                                                placeholder='Enter Fallback Value'
                                                                                                                onChange={(e) => onChangeOfCardVariablesFallbackValue(card.whatsapp_template_carousel_variation_id, variable.whatsapp_template_dynamic_variable_id, e.target.value, "body")}
                                                                                                                className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                                                disabled={checkDisableAllFields()}
                                                                                                            />
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                );
                                                                                            })}
                                                                                        </TableBody>
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                } 

                                                                {/* Card Button Variables */}
                                                                {flagShowButtonVariableForCarouselTemplate(card.whatsapp_template_carousel_variation_id, messageTemplateDetail) && 
                                                                    <Grid item xs={12}>
                                                                        <Grid container gap={1}>
                                                                            <Grid item xs={12}>
                                                                                <Typography className={style.assignValuesTitle}>Button for Card {cardIndex+ 1} <Required /></Typography>
                                                                            </Grid>
                                                                            <Grid item className={globalStyles.fullwidth}> 
                                                                                <TemplateVariableTable
                                                                                    templateType='carousel'
                                                                                    tableBodyContent={
                                                                                        <TableBody>
                                                                                            {getAllButtonVariableData(card.whatsapp_template_button)?.map((variable, ind) => {
                                                                                                return (
                                                                                                    <TableRow key={ind} className={style.tableRow}>
                                                                                                        <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                                                        <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                                            <Grid container direction={"column"}>
                                                                                                                <TextField
                                                                                                                    value={campaignPayload.campaign_carousel_card?.find((cCard) => cCard.whatsapp_template_carousel_variation_id == card.whatsapp_template_carousel_variation_id)?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                                                                    placeholder={`Enter full URL for ${getVisitWebsiteUrl(card.whatsapp_template_button, variable.whatsapp_template_dynamic_variable_id)}`}
                                                                                                                    onChange={(e) => onChangeOfCardVariablesFallbackValue(card.whatsapp_template_carousel_variation_id, variable.whatsapp_template_dynamic_variable_id, e.target.value, "button")}
                                                                                                                    className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                                                    disabled={checkDisableAllFields()}
                                                                                                                />
                                                                                                                {inValidId.includes(variable.whatsapp_template_dynamic_variable_id) && <span className={style.invalidUrlSpan}>Please Enter Valid URL</span>}
                                                                                                            </Grid>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                );
                                                                                            })}
                                                                                        </TableBody>
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </>
                            : 
                            <>
                                {flagShowHeaderVariables() &&
                                    <>
                                        <Grid item>
                                            <Typography className={style.assignValuesTitle}>Template Header</Typography>
                                        </Grid>

                                        <Grid item className={globalStyles.fullwidth}> 
                                            <TemplateVariableTable
                                                templateType='basic'
                                                variableType='header'
                                                tableBodyContent={
                                                    <TableBody>
                                                        {messageTemplateDetail?.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.map((variable, ind) => {
                                                            return (
                                                                <TableRow key={ind} className={style.tableRow}>
                                                                    <TableCell className={`${style.tableSubHeadingFontStyle} ${style.headerVariableTableCell} ${style.headerVariableTableCellKey}`}>
                                                                        {variable.whatsapp_template_dynamic_variable_key}
                                                                    </TableCell>
                                                                    <TableCell className={`${style.tableSubHeadingFontStyle} ${style.headerVariableTableCell}`}>
                                                                        <Autocomplete
                                                                            className={`${style.whatsappCampaignDropDowns} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                            options={(campaignContactData && campaignContactData[0].contact && campaignContactData[0].contact.length > 0 && campaignContactData[0].contact[0].contact_data.length > 0) ? campaignContactData[0].contact[0].contact_data.map((contact: campaignContactData) => contact.contact_field_name) : []}
                                                                            // value={getValueFromContactData(Number(campaignPayload.campaign_variable[ind]?.contact_field_id))} 
                                                                            value={getValueFromContactData(Number(campaignPayload.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.contact_field_id))}
                                                                            getOptionLabel={(option) => option}
                                                                            onChange={(e, value) => { handleChangeField(value, ind, "header", variable?.whatsapp_template_dynamic_variable_id) }}
                                                                            renderInput={(params) => <TextField {...params} placeholder="Eg. PhoneNumber, firstName" />}
                                                                            disabled={checkDisableAllFields()}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell className={`${style.tableSubHeadingFontStyle} ${style.headerVariableTableCell}`}>
                                                                        {renderHeaderVariableValue(ind, variable.whatsapp_template_dynamic_variable_id, variable?.whatsapp_template_dynamic_variable_key)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        })}
                                                    </TableBody>
                                                }
                                            />
                                        </Grid>
                                    </>
                                }

                                {flagShowBodyVariable() &&
                                    <>
                                        <Grid item>
                                            <Typography className={style.assignValuesTitle}>Template body</Typography>
                                        </Grid>
                                        <Grid item className={globalStyles.fullwidth}>
                                            {messageTemplateDetail && 
                                                <TemplateVariableTable
                                                    templateType='basic'
                                                    variableType='body'
                                                    tableBodyContent={
                                                        <TableBody>
                                                            {messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data &&
                                                                messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.length > 0
                                                                ?
                                                                (messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body.whatsapp_template_body_variable_data.sort((a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id)).map((variable, ind) => {
                                                                    const updatedIndex = updatedIndexForBodyVariables(ind);
                                                                    return (
                                                                        <TableRow key={ind} className={style.tableRow}>
                                                                            <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                            <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                <Autocomplete
                                                                                    className={`${style.whatsappCampaignDropDowns} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                    // options={valueDropdownOptions}
                                                                                    options={(campaignContactData && campaignContactData[0].contact && campaignContactData[0].contact.length > 0 && campaignContactData[0].contact[0].contact_data.length > 0) ? campaignContactData[0].contact[0].contact_data.map((contact: campaignContactData) => contact.contact_field_name) : []}
                                                                                    // value={getValueFromContactData(Number(campaignPayload.campaign_variable[updatedIndex]?.contact_field_id))} 
                                                                                    value={getValueFromContactData(Number(campaignPayload?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.contact_field_id))}
                                                                                    getOptionLabel={(option) => option}
                                                                                    onChange={(e, value) => { handleChangeField(value, updatedIndex, "body", variable?.whatsapp_template_dynamic_variable_id) }}
                                                                                    renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                    disabled={checkDisableAllFields()}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                <TextField
                                                                                    // value={campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value ? campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value : ""} 
                                                                                    value={campaignPayload?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                                    placeholder='Enter Value'
                                                                                    onChange={(e) => { handleChangeFallbackValue(e.target.value, updatedIndex, "body", variable.whatsapp_template_dynamic_variable_id); }}
                                                                                    className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                    disabled={checkDisableAllFields()}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })
                                                                :
                                                                <TableRow className={style.tableRow}>
                                                                    <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                                        No Data Available
                                                                    </TableCell>
                                                                </TableRow>
                                                            }
                                                        </TableBody>
                                                    }
                                                />
                                            }
                                        </Grid>
                                    </>
                                }

                                {flagShowButtonVariable() &&
                                    <>
                                        <Grid item>
                                            <Typography className={style.assignValuesTitle}>Template Button</Typography>
                                        </Grid>
                                        <Grid item className={globalStyles.fullwidth}>
                                            {messageTemplateDetail && 
                                                <TemplateVariableTable
                                                    templateType='basic'
                                                    variableType='button'
                                                    tableBodyContent={
                                                        <TableBody>
                                                            {buttonVariableData ?
                                                                buttonVariableData.sort((a, b) => a.whatsapp_template_dynamic_variable_id - b.whatsapp_template_dynamic_variable_id).map((variable, ind) => {
                                                                    const updatedIndex = updatedIndexForBtnVariable(ind);
                                                                    return (
                                                                        <TableRow key={ind} className={style.tableRow}>
                                                                            <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                                                            <TableCell className={style.tableSubHeadingFontStyle}>
                                                                                <Autocomplete
                                                                                    className={`${style.whatsappCampaignDropDowns} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                    // options={valueDropdownOptions} 
                                                                                    options={(campaignContactData && campaignContactData[0].contact && campaignContactData[0].contact.length > 0 && campaignContactData[0].contact[0].contact_data.length > 0) ? campaignContactData[0].contact[0].contact_data.map((contact: campaignContactData) => contact.contact_field_name) : []}
                                                                                    // value={getValueFromContactData(Number(campaignPayload.campaign_variable[updatedIndex]?.contact_field_id))}
                                                                                    value={getValueFromContactData(Number(campaignPayload.campaign_variable.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable?.whatsapp_template_dynamic_variable_id)?.contact_field_id))}
                                                                                    getOptionLabel={(option) => option}
                                                                                    onChange={(e, value) => { handleChangeField(value, updatedIndex, "button", variable?.whatsapp_template_dynamic_variable_id) }}
                                                                                    renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                                    disabled={checkDisableAllFields()}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell className={`${style.tableSubHeadingFontStyle} ${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                                                                                <TextField
                                                                                    // value={campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value ? campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value : ""}
                                                                                    value={campaignPayload?.campaign_variable.find((vari) => vari.whatsapp_template_dynamic_variable_id == variable?.whatsapp_template_dynamic_variable_id)?.campaign_variable_fallback_value || ""}
                                                                                    placeholder={`Enter full URL for ${getVisitWebsiteUrl(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button, variable.whatsapp_template_dynamic_variable_id)}`}
                                                                                    onChange={(e) => { handleChangeFallbackValue(e.target.value, updatedIndex, "button", variable.whatsapp_template_dynamic_variable_id); }}
                                                                                    className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                                    sx={{ border: inValidId.includes(ind + updatedIndex) ? "1px solid red" : "" }}
                                                                                    disabled={checkDisableAllFields()}
                                                                                />
                                                                                {inValidId.includes(variable.whatsapp_template_dynamic_variable_id) && <span className={`${style.invalidUrlSpan}`}>Please Enter Valid URL</span>}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })
                                                                :
                                                                <TableRow className={style.tableRow}>
                                                                    <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                                        No Data Available
                                                                    </TableCell>
                                                                </TableRow>
                                                            }
                                                        </TableBody>
                                                    }
                                                />
                                            }
                                        </Grid>
                                    </>
                                }
                            </>
                        }
                    
                        {isFlowTemplate(messageTemplateDetail) && flagShowFlowVariables() && 
                            <>
                                <Grid item>
                                    <Typography className={style.assignValuesTitle}>Flow Variables</Typography>
                                </Grid>
                                <Grid item className={globalStyles.fullwidth}>
                                    {messageTemplateDetail && 
                                        <TemplateVariableTable
                                            templateType='basic'
                                            variableType='flow'
                                            tableBodyContent={
                                                <TableBody>
                                                    {getFlowInputVariablesFromTemplate(messageTemplateDetail)?.map((flowVariable: flowVariables, ind: number) => {
                                                        return (
                                                            <TableRow key={ind} className={style.tableRow}>
                                                                <TableCell className={style.tableSubHeadingFontStyle}>{flowVariable.variable_key}</TableCell> 
                                                                <TableCell className={style.tableSubHeadingFontStyle}>
                                                                    <Autocomplete
                                                                        className={`${style.whatsappCampaignDropDowns} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                        // options={valueDropdownOptions} 
                                                                        options={(campaignContactData && campaignContactData[0].contact && campaignContactData[0].contact.length > 0 && campaignContactData[0].contact[0].contact_data.length > 0) ? campaignContactData[0].contact[0].contact_data.map((contact: campaignContactData) => contact.contact_field_name) : []}
                                                                        // value={getValueFromContactData(Number(campaignPayload.campaign_variable[updatedIndex]?.contact_field_id))}
                                                                        value={getValueFromContactData(Number(campaignPayload.campaign_variable.find((vari) => vari.whatsapp_template_dynamic_variable_id == flowVariable?.whatsapp_flow_variable_id)?.contact_field_id))}
                                                                        getOptionLabel={(option) => option}
                                                                        onChange={(e, value) => { handleChangeField(value, ind, "flow", flowVariable?.whatsapp_flow_variable_id) }}
                                                                        renderInput={(params) => <TextField {...params} placeholder="Select" />}
                                                                        disabled={checkDisableAllFields()}
                                                                    />
                                                                </TableCell> 
                                                                <TableCell className={style.tableSubHeadingFontStyle}>
                                                                    <TextField
                                                                        // value={campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value ? campaignPayload?.campaign_variable[updatedIndex]?.campaign_variable_fallback_value : ""} 
                                                                        value={campaignPayload?.campaign_variable?.find((vari) => vari.whatsapp_template_dynamic_variable_id == flowVariable?.whatsapp_flow_variable_id)?.campaign_variable_fallback_value || ""}
                                                                        placeholder='Enter Value'
                                                                        onChange={(e) => { handleChangeFallbackValue(e.target.value, ind, "flow", flowVariable.whatsapp_flow_variable_id); }}
                                                                        className={`${style.whatsappCampaignTextField} ${style.templateVariableMappingFieldsMinWidth}`}
                                                                        disabled={checkDisableAllFields()}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            }
                                        />
                                    }
                                </Grid>
                            </>
                        }

                    </Grid>
                </Grid>
                :
                <></>
            }
        </>
    )
}

export default CampaignVariableMapping
